import { render, staticRenderFns } from "./ForbiddenPage403.vue?vue&type=template&id=c8f4eb9c"
import script from "./ForbiddenPage403.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports